import LinkButton from '@components/link/linkButton';
import { FileTypes, ResourceFiles } from '@src/utils/enums';
import { connect } from 'redux-bundler-react';
import { TableWrapper } from './FormAndAppendices';

const FormsAndAppendicesPermit = connect('doDownloadFile', ({ doDownloadFile }) => (
  <>
    <p>
      This path will assist property owners or their agents in providing the information necessary to ensure that their
      proposed project meets the terms and conditions of the Permit(s) they intend to use.
    </p>
    <TableWrapper>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.Eng4345, FileTypes.Resource)}>
            ENG 4345 Application for Department of the Army (DA) Permit [PDF, 3 pages]
          </LinkButton>
        </td>
        <td>
          This form is used for all applications for Department of the Army (DA) Permits and Letters of Permission. View
          the Department of the Army (DA) Permit Application Guide for instructions.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.Eng6082, FileTypes.Resource)}>
            ENG 6082 Nationwide Permit Pre-Construction Notification (PCN) [PDF, 3 pages]
          </LinkButton>
        </td>
        <td>
          This form is used to provide notification to USACE regarding an applicant's desire to use a particular General
          Permit.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.Eng4345ProjectInfo, FileTypes.Resource)}>
            Project Information Sheet [PDF, 2 pages]
          </LinkButton>
        </td>
        <td>
          This form provides additional information entered throughout the request screens that is not provided on the
          Department of the Army (DA) Permit form or in the Supporting Information form.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.Eng6295, FileTypes.Resource)}>
            ENG 6295 Agent Authorization Form [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          This form indicates that the property owner has given permission to an agent/consultant to act on his or her
          behalf in all matters relating to obtaining a Department of the Army (DA) authorization.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.Eng6294, FileTypes.Resource)}>
            ENG 6294 Right of Entry [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          This form provides permission to the USACE Project Manager to enter the property for which the Department of
          the Army (DA) Permit application is being prepared.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.ImpactMitBulkUploadGuide, FileTypes.Resource)}>
            Impacts and Mitigation Bulk Upload Guide [PDF, 2 pages]
          </LinkButton>
        </td>
        <td>
          This guide provides detailed information on how to prepare and upload information for multiple impacts or
          mitigation on a parcel of property.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AdjPropertyOwnerBulkUploadCSV, FileTypes.Resource)}>
            Adjoining Property Owner Bulk Upload CSV Template [CSV, 0.29 KB]
          </LinkButton>
        </td>
        <td>Used for uploading adjoining property owners in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.PropertyOwnerBulkUploadCSV, FileTypes.Resource)}>
            Property Owner Bulk Upload CSV Template [CSV, 0.29 KB]
          </LinkButton>
        </td>
        <td>Used for uploading property owners in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.ARBulkUploadCSV, FileTypes.Resource)}>
            Resource Bulk Upload CSV Template [CSV, 0.16 KB]
          </LinkButton>
        </td>
        <td>Used for uploading centroids associated with aquatic resources in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.ImpactBulkUploadCSV, FileTypes.Resource)}>
            Impact Bulk Upload CSV Template [CSV, 0.21 KB]
          </LinkButton>
        </td>
        <td>Used for uploading impacts for related aquatic resources in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.PRMBulkUploadCSV, FileTypes.Resource)}>
            Permittee Responsible Mitigation Bulk Upload CSV Template [CSV, 0.24 KB]
          </LinkButton>
        </td>
        <td>Used for uploading permittee responsible mitigation for related aquatic resources in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.MitBankIlfBulkUploadCSV, FileTypes.Resource)}>
            Mitigation Bank In-Lieu Fee Bulk Upload CSV Template [CSV, 0.34 KB]
          </LinkButton>
        </td>
        <td>Used for uploading mitigation bank or in-lieu fee credit information in a CSV format.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixA2, FileTypes.Resource)}>
            App. A2 Adjoining Property Owners [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          Names and addresses of all property owners, lessees, etc., whose property adjoins the project site and
          properties that adjoin the waterbody or aquatic site where the work is being proposed. This information is
          used to notify the property owners of the project by Public Notice.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixB, FileTypes.Resource)}>
            App. B Aquatic Resources [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          Inventory of aquatic resources on the property that may or may not be jurisdictional under the Clean Water
          Act.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixC, FileTypes.Resource)}>
            App. C Impact Inventory [PDF, 2 pages]
          </LinkButton>
        </td>
        <td>Inventory of proposed impacts to aquatic resources on specific piece of property.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixD1, FileTypes.Resource)}>
            App. D1 Mitigation Inventory MB and ILF [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          Proposed mitigation that will be obtained from either (or both) a mitigation bank or an In-Lieu Fee program.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixD2, FileTypes.Resource)}>
            App. D2 Mitigation Inventory PRM [PDF, 1 page]
          </LinkButton>
        </td>
        <td>Proposed mitigation that will be undertaken by a permittee either on-site or off-site.</td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixE, FileTypes.Resource)}>
            App. E Dredging Project Information Sheet [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          Information pertaining to proposed dredging impacts that include the type of material being dredged,
          quantities, and disposal locations.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixF, FileTypes.Resource)}>
            App F. Shoreline Stabilization Project Information Sheet [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          If you entered yes to the question regarding bank stabilization this will include information about how the
          project will be constructed (using pilings or fill), dimensions of the structure, etc.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixG, FileTypes.Resource)}>
            App G. Pile Driving Information Sheet [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          If you entered yes to the question regarding pilings this will include information about the type, material,
          diameter, installation method, construction method, etc.
        </td>
      </tr>
      <tr>
        <td>
          <LinkButton onClick={() => doDownloadFile(ResourceFiles.AppendixH, FileTypes.Resource)}>
            App H. Supporting Information [PDF, 1 page]
          </LinkButton>
        </td>
        <td>
          Information that is uploaded by the requestor to support and/or clarify the request that is being made. This
          information can include, but is not limited to, photos, maps, drawings, other authorizations, mitigation
          plans, etc.
        </td>
      </tr>
    </TableWrapper>
  </>
));

export default FormsAndAppendicesPermit;
